import { useContext, useEffect } from 'react';
import Head from 'next/head';
// import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Tariffs from '@/components/blocks/Tariffs';
import Faq from '@/components/blocksMiniBuisness/Faq';
// import RequestDemo2 from '@/components/blocks/RequestDemo2';
import SendSignBanner from '@/components/blocks/SendSignBanner';
import RequestDemoBanner from '@/components/blocks/RequestDemoBanner';
import RegisterBanner from '@/components/blocks/RegisterBanner';
// import Signature from '@/components/blocks/Signature';
// import AdditionalSetting from '@/components/blocks/AdditionalSetting';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import { queries } from '@/helpers/api';
import { analytics } from '@/helpers/analytics';
import { ThemeContext } from '@forma/forma-ui-kit';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

// import styles from './Homepage.module.css';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await queries.getMainData(params.locale);
  const pageData = await queries.getPageData(params.locale, 'tariffs');
  const tariffsData = await queries.getTariffsData(params.locale);
  const signatureTariffs = await queries.getSignatureTariffs(params.locale);
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
      },
      page: pageData,
      tariffs: tariffsData,
      signatureTariffs,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const TariffsPage = ({ tariffs, page, signatureTariffs }) => {
  const { t } = useTranslation();

  const metaData = {
    title: t('meta_titles.tariffs'),
    description: t('meta_descriptions.tariffs'),
    keywords: t('main_keywords'),
  };
  const { lang } = useContext(ThemeContext);
  useMetaTags({ lang, ...metaData });

  const { faq, request_demo } = page;

  useEffect(() => {
    analytics.viewTariffsPage();
  }, []);

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <Tariffs items={tariffs} />
      <SendSignBanner />
      {/* <Signature tariffs={signatureTariffs} /> */}
      {/* <AdditionalSetting /> */}
      <Faq {...faq} />
      <RequestDemoBanner {...request_demo} />
      <RegisterBanner />
      {/* <RequestDemo2
        title="Запросите демонстрацию сервиса"
        subtitle="Заполните поля ниже, чтобы оставить заявку на демонстрацию сервиса с экспертом в формате видео-встречи. Проанализируем ваши бизнес-процессы и покажем работу платформы за 15 минут."
        buttonText={t('request_demo')}
        image={<Image className={styles.requestDemoImage} src="/images/demo-image-2.webp" width={506} height={370} alt="Форма - Демонстрация" />}
      /> */}
    </div>
  );
};

export default TariffsPage;
